import BlogSlider from "@/components/common/BlogSlider";
import ClientLogo from "@/components/common/ClientLogo";
import Hero from "@/components/data-solution/Hero";
import InquirySection from "@/components/data-solution/InquirySection";
import OurIndustries from "@/components/data-solution/OurIndustries";
import OurServices from "@/components/data-solution/OurServices";
import ServicesProvider from "@/components/data-solution/ServicesProvider";
import Testimonials from "@/components/data-solution/Testimonials";
import WeAre from "@/components/data-solution/WeAre";
import WeOffer from "@/components/data-solution/WeOffer";
import WorkWithUs from "@/components/data-solution/WorkWithUs";
import Layout from "@/components/layout/Layout";
import { cmsUrl } from "@/utils/helper";
import axios from "axios";
// import CaseStudyCarousel from "@/components/data-solution/CaseStudyCarousel";

const DataSolution = ({ data }) => {
  return (
    <Layout
      canonicalLink="https://ultroneous.com/web-scraping-services"
      description="Explore unmatched web scraping excellence with UltroNeous. Our expert services deliver powerful data insights for smarter decision-making"
      title="ultroNeous: Best Web Scraping Services | Data Scraping Experts"
      ogImage={
        "https://ultroneous.com/assets/services/custom-software/custom-software-og.webp"
      }
    >
      <Hero />
      <InquirySection
        buttonName="Get Free Sample Data"
        id="DataScraping-hero"
        className="!pt-0 pb-20 xl:pb-40"
        />
      <ClientLogo />
      <ServicesProvider />
      <WeOffer />
      <WeAre />
      <OurServices />
      <OurIndustries />
      <InquirySection
        buttonName="Get Free Sample Data"
        id="DataScraping"
      />
      <WorkWithUs />
      {/* <CaseStudyCarousel /> */}
      <Testimonials link="#DataScraping" />
      <div className="py-20 md:py-24">
        {data.blog.length > 0 ? <BlogSlider list={data.blog} /> : <></>}
      </div>
    </Layout>
  );
};
export async function getServerSideProps() {
  let blogData;
  try {
    blogData = await axios
      .get(`${cmsUrl}/wp-json/wp/v2/posts?categories=1`)
      .then((getblog) => getblog);
  } catch (error) {
    blogData = { data: [] };
  }

  return {
    props: {
      data: {
        blog: blogData ? blogData?.data : [],
      },
    },
  };
}
export default DataSolution;
